import ErrorBoundary from '@Components/ErrorBoundary';
import DeliverySection from '../../DeliverySection';

import type { FC } from 'react';
import type { DeliverySectionProps } from '../../DeliverySection';

const Delivery: FC<DeliverySectionProps> = (props) => {
  const { title, delivery, goodsInfo, ...restProps } = props;

  return (
    <section {...restProps}>
      <ErrorBoundary fallback={null}>
        <DeliverySection
          title={title}
          delivery={delivery}
          goodsInfo={goodsInfo}
          data-testid='delivery-assembling'
        />
      </ErrorBoundary>
    </section>
  );
};

export default Delivery;
